import React, { useEffect, useState } from 'react'
import './AllCoaPage.css'
import './Table.css'
import { Link, useNavigate } from 'react-router-dom'
import { clearError, getCoas } from '../redux/actions/productAction'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from "react-js-pagination";
import { FaEdit, FaEye } from 'react-icons/fa'
import Header from '../Components/Header'
import { getDate } from '../utils/getDate'



const AllCoaPage = () => {
  const { error, loading, coas, totalCoa, resultPerPage } = useSelector((state) => state.getCoa)
  const { products } = useSelector((state) => state.getProducts)

  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [keyword, setKeyword] = useState("")
  const [page, setPage] = useState(1)

  const [print, setPrint] = useState('all')
  const [selProduct, setSelProduct] = useState('')

  useEffect(() => {
    if (keyword === '') {
      dispatch(getCoas(keyword, page, print, selProduct))
    }

  }, [dispatch, page, keyword, print, selProduct]);

  useEffect(() => {
    if (error) {
      alert(error)
      dispatch(clearError())
    }
  }, [error]);



  const handleSearch = () => {
    setSelProduct('')
    setPrint('')
    dispatch(getCoas(keyword, page, print, selProduct))
  }

  const radioHandle = (e) => {
    setKeyword('')
    setPrint(e.target.value)
  }

  return (
    <>

      <Header />

      <div className='topSpace listCoaContainer'>
        <p>{print === 'all' && "All Documents "}
          {print === 'coa' && "Number of COA's "}
          {print === 'spec' && "Number of Spec's "}
          {print === '' && "Search Results "}
          : {totalCoa}</p>

        <div className="coaList">
          <div className="homeContainer">

            <div className="topNavBox">

              <div className='printBox1'>
                <p>Select : </p>

                <div className='printRadio'>
                  <label>
                    <input type="radio" onChange={radioHandle} name="print" value="coa" />
                    COA
                  </label>
                  <label>
                    <input type="radio" onChange={radioHandle} name="print" value="spec" />
                    SPEC
                  </label>
                  <label>
                    <input type="radio" onChange={radioHandle} name="print" selected value="all" />
                    ALL
                  </label>
                </div>
              </div>

              <div className='dropdownBox'>
                <p>Select Product</p>
                {/* Select input with options */}
                <select value={selProduct} onChange={e => setSelProduct(e.target.value)}>
                  <option className='option' value="">Select</option>
                  {
                    products?.map(item => (
                      <option className='option' value={item._id}>{item.NAME}</option>
                    ))
                  }

                </select>
              </div>

              <div className='search-Box'>
                <input
                  type="text"
                  placeholder="Search products..."
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
                <button onClick={handleSearch}>Search</button>
              </div>
            </div>

            <div className="tableBox">
              <div className="tableBoxMain">
                <div className="tableHeader bg">
                  <div className="s-no">S.No.</div>
                  <div className="tableItemProduct">Document</div>
                  <div className="tableItemProduct">Product Name</div>
                  <div className="tableItemChamical">Company Name</div>
                  <div className="tableItem">Created At</div>
                  <div className="tableItem">Created By</div>
                  <div className="tableItem">Actions</div>
                  {/* <div className="tableItem">FEMA</div> */}
                </div>
                <br />
                {coas?.map((item, i) =>
                  <div className={`tableHeader itemBox  ${i % 2 ? 'bg1' : 'bg2'}`}>
                    <div className="s-no1">{i + 1}</div>
                    <div className="tableItemProduct1">{item.type} </div>
                    <div className="tableItemProduct1">{item.NAME} </div>
                    <div className="tableItemChamical1">{item.name}</div>
                    <div className="tableItem1">{getDate(item.Date)}</div>
                    <div className="tableItem1">{item.createBy ? item.createBy : '--' }</div>
                    <div className="tableItem1">
                      <Link to={`/coa/${item._id}`} ><FaEye color='gray' /></Link>
                      <Link to={`/coa-edit/${item._id}`} ><FaEdit color='gray' /></Link>
                    </div>
                    {/* <div className="tableItem1">{item.FEMA}</div> */}
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>

        <div className='paginationBox' >
          {
            totalCoa > resultPerPage && <Pagination
              activePage={page}
              itemsCountPerPage={resultPerPage}
              totalItemsCount={totalCoa}
              pageRangeDisplayed={5}
              onChange={e => setPage(e)}
            />
          }

        </div>



      </div>
    </>

  )
}

export default AllCoaPage